import { SxProps, Theme } from "@mui/material/styles";
import * as Global from "styles/global/global.styles";
import { AlertColor } from "@mui/material";

interface AlertCSSProps {
    __style: SxProps<Theme>;
    __postion: SxProps<Theme>;
}
export function IconCSS(severity: AlertColor): SxProps<Theme> {
    switch (severity) {
        case "error":
            return {
                color: Global.colors().__attention.error.icon,
            };
        case "warning":
            return {
                color: Global.colors().__attention.warning.icon,
            };
        case "info":
            return {
                color: Global.colors().__attention.info.icon,
            };
        case "success":
            return {
                color: Global.colors().__attention.success.icon,
            };
    }
}
export function AlertCSS(severity: AlertColor): AlertCSSProps {
    switch (severity) {
        case "error":
            return {
                __style: {
                    display: "flex",
                    alignItems: "center",
                    backgroundColor:
                        Global.colors().__attention.error.background,
                    color: Global.colors().__attention.error.text,
                    border: `2px solid ${Global.colors().__attention.error.borderColor}`,
                    borderRadius: "15px",
                    px: "1.5rem",
                },
                __postion: {
                    bottom: "100px !important",
                    right: "1rem !important",
                    left: "1rem !important",
                    width: "fit-content",
                },
            };
        case "warning":
            return {
                __style: {
                    display: "flex",
                    alignItems: "center",
                    backgroundColor:
                        Global.colors().__attention.warning.background,
                    color: Global.colors().__attention.warning.text,
                    border: `2px solid ${
                        Global.colors().__attention.warning.borderColor
                    }`,
                    borderRadius: "15px",
                    px: "1.5rem",
                },
                __postion: {
                    bottom: "100px !important",
                    right: "1rem !important",
                    left: "1rem !important",
                    width: "fit-content",
                },
            };
        case "info":
            return {
                __style: {
                    display: "flex",
                    alignItems: "center",
                    backgroundColor:
                        Global.colors().__attention.info.background,
                    color: Global.colors().__attention.info.text,
                    border: `2px solid ${Global.colors().__attention.info.borderColor}`,
                    borderRadius: "15px",
                    px: "1.5rem",
                },
                __postion: {
                    bottom: "10px !important",
                    right: "1rem !important",
                    left: "1rem !important",
                    width: "fit-content",
                },
            };
        case "success":
            return {
                __style: {
                    display: "flex",
                    alignItems: "center",
                    backgroundColor:
                        Global.colors().__attention.success.background,
                    color: Global.colors().__attention.success.text,
                    border: `2px solid ${
                        Global.colors().__attention.success.borderColor
                    }`,
                    borderRadius: "15px",
                    px: "1.5rem",
                },
                __postion: {
                    bottom: "100px !important",
                    right: "1rem !important",
                    left: "1rem !important",
                    width: "fit-content",
                },
            };
    }
}
